import { Module } from 'vuex'
import { StateInterface } from '@/store'

export interface NotificationsState {
  count: number
  items: Array<Notification>
}

const NotificationsModule: Module<NotificationsState, StateInterface> = {
  namespaced: true,
  state: {
    count: 0,
    items: []
  },
  mutations: {
    SetCount: (state: NotificationsState, count: number) => {
      state.count = Math.max(0, count || 0)
    },
    SetItems: (state: NotificationsState, items: Array<Notification> | Notification) => {
      state.items = Array.isArray(items) ? items : [items]
      state.count = state.items.length
    },
    AddItems: (state: NotificationsState, items: Array<Notification> | Notification) => {
      state.items = state.items.concat(items)
      state.count = state.items.length
    },
    RemoveItems: (state: NotificationsState, items: Array<string> | string) => {
      const ids = Array.isArray(items) ? items : [items]
      ids.forEach(id => {
        // NOTE casting to any briefly since ozone ServiceNotification deviates from the standard node notification
        const index = state.items.findIndex(n => (n as any).sys?.id === id || n.tag === id)
        if (index >= 0) {
          state.items.splice(index, 1)
          state.count = Math.max(state.count - 1, 0)
        }
      })
    }
  },
  getters: {
    Items: state => state.items,
    Notifications: state => state.items,
    Count: state => state.count
  },
  actions: {
    async Count ({ state, commit, dispatch, rootGetters }, query) {
      // rootGetters['Services/Sys'].
      const {items: [{count}]} = await rootGetters['Services/Directr'].notifications.count(query)

      commit('SetCount', count)
      return state.count
    },
    async Fetch ({ state, commit, dispatch, rootGetters }, query) {
      const {sys, items: notifications} = await rootGetters['Services/Directr'].notifications.list(query)
      commit('SetItems', notifications)
      return state.items
    },
    async Get ({ state, commit, dispatch, rootGetters }, id) {
      const {sys, items: notifications} = await rootGetters['Services/Directr'].notifications.get(id)
      commit('AddItems', notifications)
      return state.items
    },
    async Clear ({ state, commit, dispatch, rootGetters }) {
      const success = await rootGetters['Services/Directr'].notifications.clear()
      commit('SetItems', [])
      return true
    },
    async Remove ({ state, commit, dispatch, rootGetters }, id) {
      const {items: removed} = await rootGetters['Services/Directr'].notifications.remove(id)
      commit('RemoveItems', id)
      return removed
    }
  }
}

export default NotificationsModule
